// extracted by mini-css-extract-plugin
module.exports = {"bonus":"_1rEcNcy","bonusImage":"_1tkvS3N"};